import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import Citation from "./Citation";

export default function Paper({ paper }) {
  const [citationOpen, setCitationOpen] = useState(false);
  const handleCite = () => {
    setCitationOpen(!citationOpen);
  };
  return (
    <>
      <Card
        sx={{
          maxWidth: 345,
          marginLeft: "5px",
          marginBottom: 5,
          backgroundColor: "var(--fourth-color)",
        }}
      >
        <CardMedia
          sx={{ height: 140 }}
          image={paper.image}
          title={paper.title}
        />
        <CardContent>
          <Typography
            gutterBottom
            variant="h7"
            component="div"
            sx={{
              color: "var(--first-color)",
              fontFamily: "var(--normal-font)",
              fontWeight: "bold",
            }}
          >
            {paper.title}
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", fontFamily: "var(--normal-font)" }}
          >
            {paper.source}
          </Typography>
        </CardContent>
        <CardActions
          sx={{ color: "var(--third-color)", fontFamily: "var(--normal-font)" }}
        >
          <Button
            size="small"
            onClick={() => {
              window.open(paper.pdf);
            }}
          >
            View
          </Button>
          <Button size="small" onClick={handleCite}>
            Cite
          </Button>
        </CardActions>
      </Card>
      {citationOpen && (
        <Citation citation={paper.citation} citationOpen={citationOpen} handleCite={handleCite}/>
      )}
    </>
  );
}
